import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Table } from 'react-bootstrap';

// import NavBar_v03Responsive from './NavBar_v03a_Responsive_component';
import { IAppConfig, IAddress, IOperatingHours } from "../../App_v01_Interfaces";

import { CompanyInfoCard, CompanyInfo  } from "./CompanyInfoCard";
interface AppConfigProps{
  appConfig: IAppConfig;
}

// Contact_LegacyInsurance_v01_A2P (updated to dual A2P consent checkboxes per ReactSet)
// Notes:
// - Shows BOTH Marketing + Non-Marketing consent checkboxes
// - Does NOT require either checkbox to be checked (submission allowed either way)
// - If neither is checked, the business should NOT send SMS (payload reflects that)


// Contact_LegacyInsurance_v01_A2P
// Update: add TWO optional A2P consent checkboxes (marketing + non-marketing)
// Placement: just above the submit button
// Behavior: NOT required (form can submit without them). If unchecked, do not SMS.

// Drop-in replacement: Contact_LegacyInsurance_v01_A2P
// Change: Replace the single smsConsent checkbox with the dual-consent block
// using the EXACT styling/structure pattern you provided (inline <style> + highlight wrapper).
// Change nothing else in the component.

const Contact_LegacyInsurance_v01_A2P_v02: React.FC<AppConfigProps> = ({ appConfig }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [form_DATA, setFormData] = useState({
    name: "",
    email: "",
    phone: "",

    // ✅ Replace legacy single checkbox with dual-consent fields
    smsMarketingConsent: false,
    smsNonMarketingConsent: false,

    message: "",
    domainName: window.location.hostname,
    itemCategory: "Customer",
    itemClass: "feedback",
    itemType: "legacy.contactus",
    clientVersion: "v03_A2P",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const isTestMode = false; // ✅ Toggle this to false in production

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsProcessing(true);

    // ✅ A2P: checkboxes are OPTIONAL; do NOT block submission.
    // If neither is checked, business must not send SMS.
    const phoneProvided = form_DATA.phone.trim().length > 0;
    const smsConsentAny = phoneProvided
      ? Boolean(form_DATA.smsMarketingConsent) || Boolean(form_DATA.smsNonMarketingConsent)
      : false;

    const smsConsentText = smsConsentAny
      ? [
          form_DATA.smsMarketingConsent
            ? `I consent to receive marketing text messages from ${appConfig.companyLegalName} at the phone number provided. Frequency may vary. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.`
            : null,
          form_DATA.smsNonMarketingConsent
            ? `I consent to receive non-marketing text messages from ${appConfig.companyLegalName} about my order updates, appointment reminders etc. Frequency may vary. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.`
            : null,
        ]
          .filter(Boolean)
          .join(" ")
      : "";

    if (isTestMode) {
      console.log("🚧 TEST MODE: Skipping API call.");
      console.table({
        domainName: form_DATA.domainName,
        customerName: form_DATA.name,
        emailAddress: form_DATA.email,
        phone: form_DATA.phone,

        smsMarketingConsent: Boolean(form_DATA.smsMarketingConsent),
        smsNonMarketingConsent: Boolean(form_DATA.smsNonMarketingConsent),
        smsConsent: smsConsentAny,
        smsConsentText,

        message: form_DATA.message,
        itemCategory: form_DATA.itemCategory,
        itemClass: form_DATA.itemClass,
        itemType: form_DATA.itemType,
        clientVersion: form_DATA.clientVersion,
      });

      setFormSubmitted(true);
      setErrorMessage("");
      setIsProcessing(false);
      return;
    }

    try {
      const response = await fetch(appConfig.contactPageAPIUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          domainName: form_DATA.domainName,
          customerName: form_DATA.name,
          emailAddress: form_DATA.email,
          phone: form_DATA.phone,

          // ✅ Send BOTH specific consent flags
          smsMarketingConsent: Boolean(form_DATA.smsMarketingConsent),
          smsNonMarketingConsent: Boolean(form_DATA.smsNonMarketingConsent),

          // ✅ Also include legacy-compatible aggregate fields
          smsConsent: smsConsentAny,
          smsConsentText,

          message: form_DATA.message,
          itemCategory: form_DATA.itemCategory,
          itemClass: form_DATA.itemClass,
          itemType: form_DATA.itemType,
          clientVersion: form_DATA.clientVersion,
        }),
      });

      if (!response.ok) {
        setIsProcessing(false);
        throw new Error(`Server responded with ${response.status}`);
      }

      setFormSubmitted(true);
      setIsProcessing(false);
      setErrorMessage("");
    } catch (err: any) {
      setIsProcessing(false);
      setErrorMessage(
        "Cloud Network Error. This form is offline. Please send your message using regular email. Thank you! :)"
      );
      console.error(err);
    }
  };

  // ✅ matches your ReactSet highlight approach
  const phoneProvided = form_DATA.phone.trim().length > 0;
  const smsConsentMissing =
    phoneProvided && !form_DATA.smsMarketingConsent && !form_DATA.smsNonMarketingConsent;

  return (
    <>
      {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

      <section className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>{appConfig.ContactUsPage.Headline}</Col>
          </Row>

          <Row>
            <Col md={6}>
              {!formSubmitted ? (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="name">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your name"
                      value={form_DATA.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      value={form_DATA.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="phone">
                    <Form.Label>Mobile Phone (optional)</Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Enter your mobile number"
                      value={form_DATA.phone}
                      onChange={handleChange}
                    />
                    <Form.Text className="text-muted">
                      Providing a phone number does not automatically enroll you in SMS — you must check a box below to opt
                      in.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="message">
                    <Form.Label>Your Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="What can we help you with?"
                      value={form_DATA.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  {/* ✅ DROP-IN: Dual A2P consent block (just above submit button) */}
                  <Col md={12}>
                    <style>{`
                      #smsConsent.form-check-input,
                      #smsMarketingConsent.form-check-input,
                      #smsNonMarketingConsent.form-check-input {
                        border: 3px solid var(--bs-primary);
                      }
                      .sms-consent-highlight .form-check-input {
                        border: 3px solid var(--bs-primary);
                        box-shadow: 0 0 0 .3rem rgba(247,201,72,0.35);
                      }
                      .consent-help {
                        margin-left: 1.75rem; /* align with checkbox label text */
                      }
                    `}</style>

                    <div className={(smsConsentMissing ? "sms-consent-highlight " : "") + "mt-2"}>
                      <Form.Check
                        type="checkbox"
                        id="smsMarketingConsent"
                        className="mt-1"
                        checked={Boolean(form_DATA.smsMarketingConsent)}
                        disabled={isProcessing}
                        onChange={(e) =>
                          setFormData((prev) => ({ ...prev, smsMarketingConsent: e.target.checked }))
                        }
                        label={
                          <span className="small" style={{ color: "var(--bs-body-color)" }}>
                            I consent to receive <span className="fw-semibold">marketing</span> text messages from{" "}
                            <span className="fw-semibold">{appConfig.companyLegalName}</span> at the phone number provided.
                            Frequency may vary. Message &amp; data rates may apply. Text HELP for assistance, reply STOP to
                            opt out.
                          </span>
                        }
                      />

                      <Form.Check
                        type="checkbox"
                        id="smsNonMarketingConsent"
                        className="mt-1"
                        checked={Boolean(form_DATA.smsNonMarketingConsent)}
                        disabled={isProcessing}
                        onChange={(e) =>
                          setFormData((prev) => ({ ...prev, smsNonMarketingConsent: e.target.checked }))
                        }
                        label={
                          <span className="small" style={{ color: "var(--bs-body-color)" }}>
                            I consent to receive <span className="fw-semibold">non-marketing</span> text messages from{" "}
                            <span className="fw-semibold">{appConfig.companyLegalName}</span> about my order updates,
                            appointment reminders etc. Frequency may vary. Message &amp; data rates may apply. Text HELP for
                            assistance, reply STOP to opt out.
                          </span>
                        }
                      />

                    <br></br>
                    </div>
                  </Col>

                  <input type="hidden" id="domainName" value={form_DATA.domainName} />
                  <input type="hidden" id="itemCategory" value={form_DATA.itemCategory} />
                  <input type="hidden" id="itemClass" value={form_DATA.itemClass} />
                  <input type="hidden" id="itemType" value={form_DATA.itemType} />

                  <Button variant="primary" type="submit" disabled={isProcessing}>
                    {isProcessing ? "Processing..." : "Send Message"}
                  </Button>
                </Form>
              ) : (
                <div className="p-3 rounded border" style={{ backgroundColor: "var(--bs-success-bg-subtle)" }}>
                  <h5>Thank you! A representative will be following up with you shortly.</h5>
                  <p>
                    <strong>Name:</strong> {form_DATA.name}
                  </p>
                  <p>
                    <strong>Email:</strong> {form_DATA.email}
                  </p>
                  {form_DATA.phone && (
                    <p>
                      <strong>Phone:</strong> {form_DATA.phone}
                    </p>
                  )}
                  <p>
                    <strong>Message:</strong> {form_DATA.message}
                  </p>

                  {form_DATA.phone && (
                    <p className="mb-0">
                      <strong>SMS Marketing Consent:</strong> {form_DATA.smsMarketingConsent ? "Yes" : "No"}
                      <br />
                      <strong>SMS Non-Marketing Consent:</strong> {form_DATA.smsNonMarketingConsent ? "Yes" : "No"}
                    </p>
                  )}
                </div>
              )}

              {errorMessage && (
                <Alert variant="danger" className="mt-3">
                  {errorMessage}
                </Alert>
              )}
            </Col>

            <Col md={6}>
              <strong>{appConfig.companyLegalName}</strong>
              <br />
              {appConfig.address.street1}, {appConfig.address.street2}
              <br />
              {appConfig.address.city}, {appConfig.address.state} {appConfig.address.zip}
              <br />

              <Container className="p-0 mt-1">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "max-content max-content",
                    columnGap: "6px",
                    rowGap: "1px",
                    alignItems: "baseline",
                  }}
                >
                  <span className="fw-boldx">Phone:</span>
                  <span>
                    <a href={"tel:" + appConfig.companyMainPhone}>{appConfig.companyMainPhone}</a>
                  </span>
                  <span className="fw-boldx">Fax:</span>
                  <span>
                    <a href={"tel:" + "303-337-5434"}>{"(303) 337-5434"}</a>
                  </span>
                </div>
              </Container>

              <p>
                <strong>Email:</strong> {appConfig.infoeMail}
              </p>

              <h5>Service Hours</h5>
              <p>
                {appConfig.operatingHours.MF}
                <br />
                {appConfig.operatingHours.SA}
                <br />
                {appConfig.operatingHours.SU}
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};


export default Contact_LegacyInsurance_v01_A2P_v02;



